//Imports
import React, { useContext, useEffect, useRef, useState } from "react";
import Select, { components } from 'react-select';
//Imports Contexts
import { AuthContext } from "../../../contexts/AuthContext";
import { AppContext } from "../../../contexts/AppContext";
import staticData from '../../../contexts/staticData.json';
//Imports Components
import AddUserForm from "../../Forms/UserForm/AddUserForm";
import EditUserForm from "../../Forms/UserForm/EditUserForm";
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
//Import Helpers
import { formatEmail } from "../../../shared/helpers";
//Imports Icons
import downArrow from '../../../assets/icons/downArrow.svg';
import contacts from '../../../assets/icons/contacts.svg';
import addUser from '../../../assets/icons/addUser.svg';
import edit from '../../../assets/icons/edit.svg';
import filter from '../../../assets/icons/filters.svg';
import warning from '../../../assets/icons/infoWhite.svg';
//Imports CSS
import './userAdministration.css';

function UserAdministration() {
    //Contextos
    const { currentUser, userData } = useContext(AuthContext);
    const { dataProjects, usersList, globalNotifications, showNotification } = useContext(AppContext);
    //Estados
    const [showSearch, setShowSearch] = useState(false);
    const [showAddUserForm, setShowAddUserForm] = useState(false);
    const [showEditUserForm, setShowEditUserForm] = useState(false);
    const [editingUserId, setEditingUserId] = useState(null);
    const [dataSearch, setDataSearch] = useState({
        region: null,
        commune: null,
        holder: { value: null, id: null }
    });
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedEstablishment, setSelectedEstablishment] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [uniqueEstablishments, setUniqueEstablishments] = useState([]);

    useEffect(() => {
        if (userData) {
            if (userData.permissions === 'admin') {
                setShowSearch(true);
            } else {
                const tenantUsers = usersList.filter((user) => user.tenantId === userData.tenantId);
                setFilteredUsers(tenantUsers);
            }
        }
    }, [userData, usersList]);

    useEffect(() => {
        if (usersList && dataSearch.holder.id) {
            const users = usersList.filter((user) => user.tenantId === dataSearch.holder.id);
            setFilteredUsers(users);
        }
    }, [usersList, dataSearch.holder.id]);

    useEffect(() => {
        const establishments = Array.from(new Set(filteredUsers.map(user => user.establishment)))
            .filter(establishment => establishment !== undefined && establishment !== null && establishment !== "");
        setUniqueEstablishments(establishments);
    }, [filteredUsers]);

    const handleSelect = (selectedOption, { name }) => {
        setDataSearch(prevState => ({
            ...prevState,
            [name]: name === 'holder'
                ? { value: selectedOption ? selectedOption.value : null, id: selectedOption ? selectedOption.id : null }
                : selectedOption ? selectedOption.value : null,
            ...(name === 'region' && { commune: null, holder: { value: null, id: null } }),
            ...(name === 'commune' && { holder: { value: null, id: null } })
        }));
    };

    const handleButtonClick = () => {
        const users = usersList.filter((user) => user.tenantId === dataSearch.holder.id);
        setFilteredUsers(users);
    };
    const handleAddUserClick = () => {
        setShowAddUserForm(true);
    };

    const handleCloseForm = (isSuccess) => {
        if (isSuccess) {
            setShowAddUserForm(false);
            setShowEditUserForm(false);
            setEditingUserId(null);
            showNotification('userAdded', true);
        } else {
            // Si se cierra sin éxito y sin error (por ejemplo, al hacer clic en "Cancelar")
            setShowAddUserForm(false);
            setShowEditUserForm(false);
            setEditingUserId(null);
        }
    };

    const departmentOptions = [
        { value: null, label: 'Todos los Departamentos' },
        ...staticData.departments.map(dept => ({ value: dept, label: dept }))
    ];

    const handleDepartmentSelect = (selectedOption) => {
        setSelectedDepartment(selectedOption ? selectedOption.value : null);
    };

    const handleEstablishmentSelect = (selectedOption) => {
        setSelectedEstablishment(selectedOption ? selectedOption.value : null);
    };

    const regionData = staticData.regiones.find((region) => region.name === dataSearch.region);
    const holders = dataProjects.filter((project) => project.commune === dataSearch.commune);
    const isButtonDisabled = !dataSearch.region || !dataSearch.commune || !dataSearch.holder.value;
    // const isButtonAddUserDisabled =
    //     (userData) ? (
    //         userData?.dimension !== 'Sostenedor' || userData?.dimension === 'Establecimiento'
    //     ) : (
    //         userData?.permissions === 'admin' && isButtonDisabled
    //     );

    const isButtonAddUserDisabled =
        (userData && userData.permissions === 'admin') ? (
            isButtonDisabled
        ) : (
            userData?.dimension !== 'Sostenedor' || userData?.dimension === 'Establecimiento'
        );

    const handleEditClick = (userId) => {
        setEditingUserId(userId);
        setShowEditUserForm(true);
    }
    return (
        <section className='container-user-administration flex'>
            {showSearch &&
                <article className='container-search flex'>
                    <article className='box-input flex'>
                        <label htmlFor='region' className='hidden-label'>Región</label>
                        <Select
                            name='region'
                            id='region'
                            options={staticData.regiones.map((region) => ({
                                value: region.name,
                                label: region.name
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label))
                            }
                            onChange={handleSelect}
                            value={dataSearch.region ? { value: dataSearch.region, label: dataSearch.region } : null}
                            placeholder='Seleccionar Region'
                            className='select-custom'
                            classNamePrefix='select-custom'
                            components={{ DropdownIndicator }}
                        />
                    </article>
                    <article className='box-input flex'>
                        <label htmlFor='commune' className='hidden-label'>Comuna</label>
                        <Select
                            name='commune'
                            id='commune'
                            options={regionData && regionData.communes.map((commune) => ({
                                value: commune.name,
                                label: commune.name
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label))}
                            onChange={handleSelect}
                            value={dataSearch.commune ? { value: dataSearch.commune, label: dataSearch.commune } : null}
                            placeholder='Seleccionar Comuna'
                            className='select-custom'
                            classNamePrefix='select-custom'
                            components={{ DropdownIndicator }}
                        />
                    </article>
                    <article className='box-input flex'>
                        <label htmlFor='holder' className='hidden-label'>Sostenedor</label>
                        <Select
                            name='holder'
                            id='holder'
                            options={holders.map((holder) => ({
                                value: holder.nameProject,
                                label: holder.nameProject,
                                id: holder.id
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label))}
                            onChange={handleSelect}
                            value={dataSearch.holder.value ? { value: dataSearch.holder.value, label: dataSearch.holder.value } : null}
                            placeholder='Seleccionar Sostenedor'
                            className='select-custom'
                            classNamePrefix='select-custom'
                            components={{ DropdownIndicator }}
                        />
                    </article>
                    <button type='button' className={`box-button active flex ${isButtonDisabled && 'disabled'}`} onClick={handleButtonClick} disabled={isButtonDisabled}>
                        <p>Administrar Usuarios</p>
                        <img src={contacts} className='icon' alt='Icono administrar usuarios' />
                    </button>
                </article>
            }
            <article className={`container-result flex ${showSearch ? 'show-search' : 'not-show'}`}>
                <article className='users-holder flex'>
                    <h3>Usuarios Sostenedor</h3>
                    <table className='table-users flex'>
                        <thead className='header-table flex'>
                            <tr className={`flex ${(userData && userData?.dimension === 'Establecimiento') ? 'establishment' : ''}`}>
                                <th>Nombre de Usuario</th>
                                <th>Usuario</th>
                                <th>Contacto</th>
                                <th>Dimensión</th>
                                <th>Departamento</th>
                                <th>Estado</th>
                                {(userData && userData?.dimension !== 'Establecimiento') && (
                                    <th>Editar</th>
                                )}
                                {/* <th>Eliminar</th> */}
                            </tr>
                            <tr className='input-filter'>
                                <th>
                                    <span className='input-select input-filter'>
                                        <label htmlFor='departmentFilter' className='label-hidden'>Departamento</label>
                                        <Select
                                            name='departmentFilter'
                                            id='departmentFilter'
                                            options={departmentOptions}
                                            placeholder='Filtra por departamento'
                                            className='custom-select'
                                            classNamePrefix='custom-select'
                                            components={{ DropdownIndicator: DropdownIndicator2 }}
                                            onChange={handleDepartmentSelect}
                                            value={selectedDepartment ? { value: selectedDepartment, label: selectedDepartment } : null}
                                        />
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className='table-body flex'>
                            {filteredUsers.length > 0 ? (
                                (() => {
                                    const filteredResults = filteredUsers
                                        .filter((user) => user.dimension === 'Sostenedor' &&
                                            (!selectedDepartment || user.department === selectedDepartment)
                                        );

                                    return filteredResults.length > 0 ? (
                                        filteredResults.map((user) => (
                                            <tr className={`flex ${(userData && userData?.dimension === 'Establecimiento') ? 'establishment' : ''}`} key={user.id}>
                                                <td data-label='Nombre'>{user.displayName}</td>
                                                <td data-label='Usuario'>{formatEmail(user.email)}</td>
                                                <td data-label='Contacto'>{user.phoneNumber ? user.phoneNumber : 'S/N'}</td>
                                                <td data-label='Dimensión'>{user.dimension}</td>
                                                <td data-label='Departamento'>{user.department}</td>
                                                <td data-label='Estado'><p className={`box-state ${user.state.toLowerCase()}`}>{user.state}</p></td>
                                                {(userData && userData?.dimension !== 'Establecimiento') && (
                                                    <td data-label='Editar' onClick={() => handleEditClick(user.id)}>
                                                        <img src={edit} className='icon' alt='Icono para editar' />
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className='flex'>
                                            <td colSpan='8'>No existen usuarios</td>
                                        </tr>
                                    );
                                })()
                            ) : (
                                <tr className='flex'>
                                    <td colSpan='8'>No existen usuarios</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </article>
                <article className='users-establishment flex'>
                    <h3>Usuarios Establecimientos</h3>
                    <table className='table-users flex'>
                        <thead className='header-table flex'>
                            <tr className='flex'>
                                <th>Nombre de Usuario</th>
                                <th>Usuario</th>
                                <th>Contacto</th>
                                <th>Dimensión</th>
                                <th>Establecimiento</th>
                                <th>Departamento</th>
                                <th>Estado</th>
                                {(userData && userData?.dimension !== 'Establecimiento') && (
                                    <th>Editar</th>
                                )}
                                {/* <th>Eliminar</th> */}
                            </tr>
                            {(userData && userData.dimension !== 'Establecimiento') && (
                                <tr className='input-filter'>
                                    <th>
                                        <span className='input-select input-filter'>
                                            <label htmlFor='establishmentFilter' className='label-hidden'>Dependencia</label>
                                            <Select
                                                name='establishmentFilter'
                                                id='establishmentFilter'
                                                options={[
                                                    { value: null, label: 'Todos los Establecimientos' },
                                                    ...uniqueEstablishments.map(establishment => ({ value: establishment, label: establishment }))
                                                ]}
                                                placeholder='Filtra por establecimiento'
                                                className='custom-select'
                                                classNamePrefix='custom-select'
                                                components={{ DropdownIndicator: DropdownIndicator2 }}
                                                onChange={handleEstablishmentSelect}
                                                value={selectedEstablishment ? { value: selectedEstablishment, label: selectedEstablishment } : null}
                                            />
                                        </span>
                                    </th>
                                </tr>
                            )}
                        </thead>
                        <tbody className='table-body flex'>
                            {filteredUsers.length > 0 ? (
                                filteredUsers
                                    .filter((user) => {
                                        const isEstablishmentUser = user.dimension === 'Establecimiento';

                                        if (userData && userData?.dimension === 'Establecimiento') {
                                            // Si el usuario actual es de Establecimiento, solo muestra usuarios de su establecimiento
                                            return isEstablishmentUser && user.establishment === userData.establishment;
                                        } else {
                                            // Para Sostenedor/admin, muestra todos los establecimientos o filtra por el seleccionado
                                            return isEstablishmentUser && (!selectedEstablishment || user.establishment === selectedEstablishment);
                                        }
                                    })
                                    .map((user) => (
                                        <tr className='flex' key={user.id}>
                                            <td data-label='Nombre'>{user.displayName}</td>
                                            <td data-label='Usuario'>{formatEmail(user.email)}</td>
                                            <td data-label='Contacto'>{user.phoneNumber ? user.phoneNumber : 'S/N'}</td>
                                            <td data-label='Dimensión'>{user.dimension}</td>
                                            <td data-label='Establecimiento'>{user.establishment}</td>
                                            <td data-label='Departamento'>{user.department}</td>
                                            <td data-label='Estado'><p className={`box-state ${user.state.toLowerCase()}`}>{user.state}</p></td>
                                            {(userData && userData?.dimension !== 'Establecimiento') && (
                                                <td data-label='Editar' onClick={() => handleEditClick(user.id)}>
                                                    <img src={edit} className='icon' alt='Icono para editar' />
                                                </td>
                                            )}
                                            {/* <td><img src={trash} className='icon' alt='Icono para eliminar' /></td> */}
                                        </tr>
                                    ))
                            ) : (
                                <tr className='flex'>
                                    <td colSpan='8'>No existen usuarios</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </article>
                {showAddUserForm && (
                    <aside className='overlay show flex'>
                        <AddUserForm
                            onClose={handleCloseForm}
                            show={showAddUserForm}
                            projectId={
                                userData && userData.permissions === 'admin'
                                    ? dataSearch.holder.id
                                    : userData?.tenantId
                            }
                        />
                    </aside>
                )}
                {showEditUserForm && (
                    <aside className='overlay show flex'>
                        <EditUserForm
                            onClose={handleCloseForm}
                            show={showEditUserForm}
                            userId={editingUserId}
                        />
                    </aside>
                )}
                <aside className='flex disabled-tooltip'>
                    <button type='button' className={`box-button flex ${isButtonAddUserDisabled ? 'disabled' : ''}`} onClick={handleAddUserClick} disabled={isButtonAddUserDisabled} >
                        <img src={addUser} className='icon' alt='Icono boton agregar nuevo usuario' />
                        <p>Agregar Nuevo Usuario</p>
                    </button>
                    {isButtonAddUserDisabled && (
                        <span className='tooltip-message flex'><img src={warning} alt='Icono de advertencia botón bloqueado' /><p>No tienes permisos suficientes.</p></span>
                    )}
                </aside>
            </article>
            <MessageConfirmation
                confirmation={globalNotifications.userAdded}
                error={false}
                view={true}
            />
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

const DropdownIndicator2 = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={filter} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default UserAdministration;